import React, { useState, useEffect } from "react";
import { Card, InputNumber, Button, Typography, message, Spin } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { getDelayTime, SetDelayTime } from "../../endpoints/API";

const { Title, Text } = Typography;

function DelayTime() {
  const [delay, setDelay] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // Fetch current delay from API
  useEffect(() => {
    const fetchDelay = async () => {
      setLoading(true);
      try {
        const res = await getDelayTime();
        const data = res?.data
        setDelay(data.delay_seconds);
      } catch (err) {
        message.error("Failed to fetch delay time");
      } finally {
        setLoading(false);
      }
    };
    fetchDelay();
  }, []);

  // Save delay time to API
  const saveDelay = async () => {
    if (delay <= 0) {
      message.warning("Delay time must be greater than 0");
      return;
    }
    setSaving(true);
    try {
      const res = await SetDelayTime({ delay_seconds: delay })
      if (!res.statusText=="OK") throw new Error();
      message.success("Delay time updated successfully!");
    } catch (err) {
      message.error("Failed to update delay time");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card
      style={{
        maxWidth: 400,
        margin: "2rem auto",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        textAlign: "center",
      }}
    >
      <Title level={4}>
        <ClockCircleOutlined style={{ marginRight: 8, color: "#1890ff" }} />
        Set Delay Time
      </Title>
      <Text type="secondary">
        Time (in minutes) before sending the alert SMS.
      </Text>

      {loading ? (
        <Spin style={{ marginTop: 20 }} />
      ) : (
        <div style={{ marginTop: 20 }}>
          <InputNumber
            min={1}
            value={delay}
            onChange={(val) => setDelay(val)}
            style={{ width: "100%" }}
          />
          <Button
            type="primary"
            block
            style={{ marginTop: 16 }}
            onClick={saveDelay}
            loading={saving}
          >
            Save Delay
          </Button>
        </div>
      )}
    </Card>
  );
}

export default DelayTime;
